module.exports = [
  {
    code: 0,
    name: 'card',
    title: 'CB'
  },
  {
    code: 1,
    name: 'cash',
    title: 'espèces'
  },
  {
    code: 2,
    name: 'check',
    title: 'chèque'
  },
  {
    code: 3,
    name: 'online',
    title: 'en ligne'
  },
  {
    code: 4,
    name: 'credit',
    title: 'avoir'
  },
  {
    code: 5,
    name: 'coupon',
    title: 'coupon'
  },
  {
    code: 6,
    name: 'ticket-restaurant',
    title: 'ticket-restaurant'
  },
  {
    code: 7,
    name: 'wire-transfer',
    title: 'virement'
  },
  {
    code: 8,
    name: 'refund',
    title: 'remboursement'
  }
];